define('GameDayCore/GDUtil/dataMapping/LocalizationUtil',['require','exports','module'],function(require,exports,module){

    exports.language = "english";

	exports.isEnglish = function() {
		return true;
	};

});
